import React from "react";
import { animated } from "react-spring";

const Icon = (props) => {
  const { onClick, onMouseDown, onMouseUp, color, type} = props;
  const styles = {
    iconStyle: {
      color: color,
      fontSize: props.fontSize ? props.fontSize : 15,
    }
  }



  return (
      <animated.span
        className={type === "outlined" ? "material-icons-outlined" : type === "filled" ? "material-icons" : "material-icons"}
        style={{...styles.iconStyle, ...props.style}}
        onClick = {onClick}
        onMouseDown = {onMouseDown}
        onMouseUp = {onMouseUp}
      >
        {props.name}
      </animated.span>
  );
};

export default Icon;
